import Failure from "./failure.json";
import Loading from "./loading.json";
import Success from "./success.json";
import SmallLoader from "./loader.json";
import SecondaryLoading from "./secondaryLoading.json";

export { Failure, Loading, Success, SmallLoader, SecondaryLoading };
